import {Urls} from '../constants'
import 'styles/homepage.scss'
import { currentUserInfo } from "../utils/currentUser.js";

const authSettings = $.sc.authSettings;

// If logged in then show the spiiner before redirect, or else show the welcome page
// function welcomePage(){
//     return `
//     <!-- Hero section -->
//     <div class="landing-page-hero-section">
//         <div class="site-container pcg-homepage-jumbotron js-homepage-jumbotron" style="background-image: url(/Resources/Councils/VirtualWallet/assets/images/BK_HEROipad-22.09_HEROipad.png?anchor=center&amp;mode=crop&amp;width=1920&amp;height=1000&amp;rnd=132767936443000000); background-color: #003399;">
//             <h1 class="pcg-homepage-jumbotron__title" data-uw-styling-context="true">Virtual Wallet</h1>
//             <div class="pcg-homepage-jumbotron__logo-wrapper">
//                 <img src="/Resources/Councils/VirtualWallet/home/logos/vw-favicon.png?anchor=center&amp;mode=crop&amp;width=270&amp;height=270&amp;rnd=132712451378970000" class="pcg-homepage-jumbotron__logo" alt="" />
//             </div>
//             <ul class="pcg-homepage-jumbotron__list" style="list-style-image: url(/media/hzcfjxyn/pink_bulletpoint-21.png?mode=max&amp;width=20&amp;upscale=false&amp;rnd=132732402008870000);">
//                 <li class="pcg-homepage-jumbotron__item">
//                     <div class="pcg-rte-wrapper"><p data-uw-styling-context="true">Easy to use</p></div>
//                 </li>
//                 <li class="pcg-homepage-jumbotron__item">
//                     <div class="pcg-rte-wrapper"><p data-uw-styling-context="true">Safe and secure</p></div>
//                 </li>
//                 <li class="pcg-homepage-jumbotron__item">
//                     <div class="pcg-rte-wrapper"><p data-uw-styling-context="true">Puts you at the heart of your support</p></div>
//                 </li>
//             </ul>

//             <div class="pcg-video-pop-up js-video-box--a854aa8bb4a1411db667d3b0a043d303">
//                 <div class="modal fade js-video-box__modal" tabindex="-1" role="dialog" aria-hidden="true">
//                     <div class="pcg-modal-dialog modal-dialog modal-dialog-centered" role="document">
//                         <div class="modal-content">
//                             <div class="pcg-video-pop-up__media-wrapper">
//                                 <iframe
//                                     id="a854aa8bb4a1411db667d3b0a043d303"
//                                     data-video-id="uIBt_dcCxG8"
//                                     data-provider="youtube"
//                                     class="js-video-box__frame"
//                                     frameborder="0"
//                                     allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
//                                     allowfullscreen=""
//                                     src="https://www.youtube-nocookie.com/embed/uIBt_dcCxG8?rel=0&amp;enablejsapi=1"
//                                     data-lf-yt-playback-inspected-3p1w24d0pnz4my5n="true"
//                                 >
//                                 </iframe>
//                             </div>
//                             <button type="button" class="pcg-modal-dialog__close close" data-dismiss="modal" aria-label="Close">
//                                 <span aria-hidden="true" data-uw-styling-context="true">×</span>
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//                 <form action="https://youtu.be/uIBt_dcCxG8" target="_blank">
//                     <button type="submit" class="pcg-video-pop-up__btn pcg-btn js-video-box__play-button" data-uw-styling-context="true">
//                         Play video
//                     </button>
//                 </form>
//             </div>
//         </div>
//     </div>


//     <!-- What is VW section -->
//     <div class="what-is-vw-section">
//         <div class="site-container pcg-homepage">
//             <div class="pcg-homepage__info-block">
//                 <div class="pcg-info-block container">
//                     <div class="row">
//                         <div class="pcg-info-block__text-col col-12 col-lg-6">
//                             <h2 class="pcg-info-block__title">What is Virtual Wallet?</h2>
//                             <div class="pcg-rte-wrapper">
//                                 <p>Virtual Wallet is a safe, user-friendly platform that brings together individuals, their personalised care funding and care providers in a secure online environment.</p>
//                                 <p>Designed around the individual, Virtual Wallet simplifies the process of managing all types of personal care funding and puts the individual in full control of the care and support they receive.</p>
//                                 <p>&nbsp;</p>
//                                 <p>
//                                     <a tabindex="0" href="/pplukttest/virtual-wallet-for-individuals/" title="Virtual Wallet for Individuals">
//                                         <span class="pcg-rte-button--default" style="text-align: center; background-color: #003399; min-width: 310px;">VW for Individuals</span>
//                                     </a>
//                                     <a tabindex="0" href="/pplukttest/virtual-wallet-for-providers/" title="Virtual Wallet for Providers">
//                                         <span class="pcg-rte-button--default" style="text-align: center; background-color: white; color: #003399; border: 2px solid #003399; min-width: 310px;">VW for Providers</span>
//                                     </a>
//                                 </p>
//                             </div>
//                         </div>
//                         <div class="d-none d-lg-block col-lg-4 offset-lg-1">
//                             <div class="pcg-info-slider js-article-slider pcg-info-block__image slick-initialized slick-slider">
//                                 <div class="slick-list draggable">
//                                     <div class="slick-track" style="opacity: 1; width: 448px;">
//                                         <div class="slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" style="width: 448px; position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;">
//                                             <div><img src="/Resources/Councils/VirtualWallet/assets/images/VW-hand-phone-22.09.png?anchor=center&amp;mode=crop&amp;width=735&amp;height=855&amp;rnd=132767931395670000" alt="" style="width: 100%; display: inline-block;" /></div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>
//     `
// };


// If not logged in then render welcome page
if(authSettings.login === null){

    //$('#maincontent').append(welcomePage());
    window.location.href = '/';

} else {

    // Hide header and footer
    $('header').hide();
    $('footer').hide();

    // Show spinner before page redirects to designated target
    $('body').prepend(
        '<div class="js-overlay" style="width: 100%; height: 100%; position: fixed; z-index: 10000000; top: 0; display: flex; justify-content: center; background-color: rgba(0, 0, 0, 0.2)">' +
        // '<svg style="width: 80px;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-spinner fa-w-16 fa-spin fa-lg"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" class=""></path></svg>' +
        '</div>'
    );

    // Redirect to these pages
    currentUserInfo(function(data) {

        let hasWorkAs = false;
        let hasPermission = false;

        // Run a loop to check for work as odule
        if ( data.AvailableModules ) {
            for ( var i = 0; i < data.AvailableModules.length; i++) {
    
                if ( data.AvailableModules[i] === 'work_as') {
                    hasWorkAs = true;
                }
            }
        }


        if(authSettings.isSag === true || authSettings.isCaseManager === true || authSettings.isCaseManagerAdmin === true){

            if ($.sc.authSettings.securityGroups.includes('4c22d50f-ae82-411f-87a9-b4520109e8e0')) {

                // ILS Users direct to the Reports page
                window.location.href = (Urls.urlpath + Urls.reportsPage);

            } else {
                window.location.href = (Urls.urlpath + Urls.vwSagDash); 
            }


        // Managed Accounts - approver Croydon
        } else if ( authSettings.organisationId === '324f8196-c77d-4f80-aac3-a99e00adb2a8' &&  authSettings.isOrgAdmin === true && authSettings.securityGroups.indexOf(Urls.approverSecurityGroup) > -1) {

            window.location.href = "/s4s/CustomPage/Index/" + Urls.manualTransactionPaymentApproval; 

        } else if ( authSettings.hasPba === true ) {

            window.location.href = (Urls.urlpath + Urls.vwDashboard); 

        } else if (authSettings.isWorkAsMode === false ){

            if (authSettings.permissions && authSettings.permissions.length > 0) {

                for (var i = 0; i < authSettings.permissions.length; i++) {

                    if (authSettings.permissions[i] === '04dad323-b630-4d06-8b9c-3f1a1ff2b328') {
                        hasPermission = true;
                    }
                }

                if ( hasPermission === true && hasWorkAs === true && $.sc.authSettings.pplId === null ) {
                    window.location.href = "/s4s/WorkAs"; 
                } else {
                    window.location.href = (Urls.urlpath + Urls.vwDashboard); 
                }  
                
            } else {
                
                window.location.href = (Urls.urlpath + Urls.vwDashboard); 
            }

        } else {

            window.location.href = (Urls.urlpath + Urls.vwDashboard); 
        }

    });

};